"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureValueTypes = {
    EXTERIOR_360: 'exterior360_24',
    DEFAULT: 'DEFAULT',
};
